import { authAxios } from "services";

export const fetchAll = (page) => authAxios().get(`/vehicleTypes?page=${page}`);

export const fetchOptions = () => authAxios().get(`/vehicleTypes/options`);

export const create = (data) => authAxios().post(`/vehicleTypes`, data);

export const fetchById = (id) => authAxios().get(`/vehicleTypes/${id}`);

export const deleteById = (id) => authAxios().delete(`/vehicleTypes/${id}`);

export const updateById = (id, data) => authAxios().post(`/vehicleTypes/${id}?_method=PUT`, data);
